module.exports = __webpack_public_path__ + "img/icon-pencil.ff79fa83.svg";